import { Dialog, DialogContent } from "@/components/ui";

import { Spin } from "../spin";
import { Typography } from "../typography";

export function LoadingDialog({ open, label }: { open: boolean; label?: string }) {
  return (
    <Dialog open={open}>
      <DialogContent className="w-40">
        <Spin className="size-10" />
        {label && (
          <Typography align="center" variant="body-sm">
            {label}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
